import { render, staticRenderFns } from "./gas.vue?vue&type=template&id=0c84f596&"
import script from "./js/gas.js?vue&type=script&lang=js&"
export * from "./js/gas.js?vue&type=script&lang=js&"
import style0 from "./gas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports